import React from 'react';
import PropTypes from 'prop-types';
import { FormAPI } from 'lecom-api';

import DocumentStoreItem from '../../models/document_store_item';
import DocumentPropertiesDefinitions from '../../constants/document_properties_definitions';
import FormFieldTypes from 'form/constants/form_field_types';
import { getCompositeProperty } from 'utils/object_utils';
import { formatDatetime, formatDate, formatNumberWithDigits } from 'utils/formatting_utils';

export default class DocumentDetails extends React.Component {

	static propTypes = {
		id: PropTypes.string,
		name: PropTypes.string,
		store: PropTypes.object
	};

	static defaultProps = {
		id: '',
		name: '',
		store: new DocumentStoreItem()
	};

	get template() {
		return this.props.store.template;
	}

	get document() {
		return this.props.store.document;
	}

	parseDocumentPropertyValue(propKey) {
		const propertyDefinition = DocumentPropertiesDefinitions[propKey];
		const propertyValue = getCompositeProperty(propertyDefinition.path || propKey, this.document);

		switch(propertyDefinition.type) {
			case 'datetime':
			return formatDatetime(propertyValue);
			default:
			return propertyValue;
		}
	}

	formatDocumentFieldValue(field, fieldValue) {
		switch (field.type) {
			case FormFieldTypes.DATE:
				return this.formatDocumentDateValue(fieldValue);
			case FormFieldTypes.CURRENCY:
				return this.formatDocumentCurrencyValue(fieldValue);
			default:
				return fieldValue;
		};
	}

	formatDocumentCurrencyValue(fieldValue) {
		if (fieldValue === undefined || fieldValue === null || fieldValue === '')
			return "-";

		const prefix = Realize.i18n.t('masks.currency.prefix');
		let returnValue = !fieldValue ? fieldValue : formatNumberWithDigits(fieldValue, 2);

		if (returnValue === "NaN") {
			returnValue = fieldValue;
		}

		return `${prefix} ${returnValue}`;
	}

	formatDocumentDateValue(stringDate) {
		let parsedIntDate = +stringDate;

		return isNaN(parsedIntDate) || !stringDate
		? formatDate(stringDate)
		: formatDate(new Date(parsedIntDate));
	}

	renderDocumentProperties() {
		return Object.keys(DocumentPropertiesDefinitions).map(p => this.renderDocumentProperty(p));
	}

	renderDocumentProperty(propertyName) {
		const propertyLabel = Realize.i18n.t(`template.attributes.${propertyName}`);
		const propertyValue = this.parseDocumentPropertyValue(propertyName);

		return this.renderDetailField(propertyLabel, propertyValue);
	}

	renderDocumentFieldValues() {
		const { inputProps } = this.props.store

		const fields = this.template.fields
		const associatedFields = inputProps.formFieldMappings
		const syncMetadata = inputProps.syncMetadata

		const fieldsToSync = syncMetadata ? associatedFields : null

		return Object.keys(fields).map((fieldName) => {
			return this.renderDocumentFieldValue(fieldName, fields[fieldName], fieldsToSync)
		});
	}

	renderDocumentFieldValue(fieldName, field, fieldsToSync) {
		const fieldLabel = field.label || fieldName

		let fieldValue = this.document.fieldValues[fieldName]

		if (fieldsToSync) {
			const associatedField = fieldsToSync.find((field) => {
				return field.documentField === fieldName
			})

			if (associatedField !== undefined) {
				const { inputProps } = this.props.store

				const formApi = FormAPI.form(inputProps.formId)
				const formFieldValue = formApi.fields(associatedField.formField.id).value()

				fieldValue = formFieldValue
			}
		}

		return this.renderDetailField(fieldLabel, this.formatDocumentFieldValue(field, fieldValue));
	}

	renderDetailField(name, value) {
		if(!value)
			value = '-';

		return [
			<dt className="col s2 m2 l2 document-details__list-item" key={`document_${this.props.id}_${name}_dt`} tabIndex="0">
				<strong>{name}</strong>
			</dt>,
			<dd className="col s10 m10 l10 document-details__list-item" key={`document_${this.props.id}_${name}_dd`} tabIndex="0">
				{value}
			</dd>
		];
	}

	renderDocumentFields() {
		//verifica se veio algum campo
		var empty = true;
		for (let field in this.template.fields) {
			if (hasOwnProperty.call(this.template.fields, field)) {
				empty = false;
				break;
			}
		}

		if (empty) return;

		return (
			<div>
				<h5 className="document-details__header" tabIndex="0">
					{Realize.i18n.t('template.titles.documentFields')}
				</h5>
				<dl className="row">
					{this.renderDocumentFieldValues()}
				</dl>
			</div>
		);
	}

	render() {
		return (
			<div className="document-details__wrapper">
				<h5 className="document-details__header" tabIndex="0">
					{Realize.i18n.t('template.titles.documentProperties')}
				</h5>
				<dl className="row document-details__list">
					{this.renderDocumentProperties()}
				</dl>

				{this.renderDocumentFields()}
			</div>
		);
	}
}
